module.exports = __webpack_public_path__ + "media/login/login_icon_ojo-c7297b3b.svg";